export const ON_ARCHIVE_SUCCESS = "on-archive-success";

export const ON_REMOVE_SUCCESS = "on-remove-success";
